<template>
    <v-dialog :value="value" persistent :max-width="900">
        <v-card style="border-radius: 16px">
            <v-card-title class="primary modal-title pa-2" primary-title>
                Histórico de Protocolos
                <v-spacer/>
                <v-btn class="close__button" text @click="fecharModal" icon>
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="container-modal-historico-protocolos">

                <v-data-table :headers="colunas" :items="protocolosList"
                              no-data-text="Não há protocolos enviados"
                              class="az-table-list tabela-historico-protocolos" hide-actions>
                    <template slot="items" slot-scope="props">
                        <td><a :href="criarLinkDownload(props.item.anexoUri)" target="_blank">{{ props.item.numero }}</a></td>
                        <td>{{ props.item.situacao }}</td>
                        <td>{{ props.item.dataHoraEnvio | az-date('DD/MM/YYYY HH:mm:ss')}}</td>
                        <td>{{ props.item.dataHoraCancelamento | az-date('DD/MM/YYYY HH:mm:ss') }}</td>
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {actionTypes} from "@/commons/constants";

export default {
    name: 'ModalHistoricoProtocolos',
    props: {
        value: {
            type: Boolean
        },
    },
    data(){
        return{
            licitacaoId: null,
            protocolosList: [],
            colunas: [
                {
                    text: 'Número Protocolo',
                    align: 'left',
                    sortable: false,
                    width: '15%',
                    class: 'primary--text'
                },
                {
                    text: 'Situação',
                    align: 'left',
                    sortable: false,
                    width: '20%',
                    class: 'primary--text'
                },
                {
                    text: 'Data/Hora Envio',
                    align: 'left',
                    sortable: false,
                    width: '32%',
                    class: 'primary--text'
                },
                {
                    text: 'Data/Hora Cancelamento',
                    align: 'left',
                    sortable: false,
                    width: '33%',
                    class: 'primary--text'
                }
            ]
        }
    },
    async mounted() {
        this.setarLicitacaoId()
        this.buscarHistoricoProtocolosFornecedor()
    },
    methods: {
        setarLicitacaoId(){
            if(this.$route.params.id){
                this.licitacaoId = this.$route.params.id
            }
        },
        async fecharModal() {
            this.$emit('fecharModalHistoricoProtocolos')
        },
        async buscarHistoricoProtocolosFornecedor(){

            const resposta = await this.$store.dispatch(actionTypes.BUSCAR_PROTOCOLOS_FORNECEDOR, this.licitacaoId)

            if(resposta){
                this.protocolosList = resposta.protocoloList
            }
        },

    }
}
</script>

<style lang="stylus" scoped>

    .container-modal-historico-protocolos
        text-align center
        display flex
        flex-direction column
        min-height 400px
        padding 0px

    .tabela-historico-protocolos
        width 100%
        table-layout fixed

        >>> th, >>> td
            white-space nowrap
            overflow hidden
            text-overflow ellipsis

</style>
